module.exports = __webpack_public_path__ + "stu-res/img/play.4e586343.png";